var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('peek-form',{attrs:{"title":_vm.$t('activity'),"footer":false}},[_c('m-infinite-activity',{attrs:{"getter":_vm.load,"height":"calc(100vh - 64px)"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }